import { useState } from "react";
import { MapPinIcon,ClockIcon  } from "@heroicons/react/24/solid"; 
import './meeting.css';

/* ---------- Venue (existing content) ---------- */
function VenueSection({
  date = new Date(2025, 10, 15),
  time = "09:00 AM",
  venue = "Seminar Hall",
  campus = "IIT Delhi",
}) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();
  const locationText = `${venue}, ${campus}`;
  // NOTE: I'm leaving the original placeholder URL as per your code.
  const mapEmbedUrl =
    "https://www.google.com/maps?q=Seminar+Hall,+IIT+Delhi&output=embed";

  return (
    <section className="venue-section-container">
      {/* Access note */}
      <div className="access-note-box">
        <p className="access-note-heading">
          For Registered Members Only
        </p>
        <p className="access-note-text">
          The IIT Women Faculty Meet is an exclusive event for registered faculty
          members within the IIT ecosystem. Please ensure your registration is
          confirmed prior to arrival.
        </p>
      </div>

      {/* Details */}
      <div className="venue-details-grid">
        {/* Date & Time */}
        <div className="venue-detail-card date-time-card">
          <h3 className="card-heading">
            Date & Time
          </h3>
          <div className="date-time-content">
            <div className="date-box">
              <span className="date-day">
                {day}
              </span>
            </div>
            <div className="date-text-group">
              <div className="date-month">{month}</div>
              <div className="date-year">{year}</div>
            </div>
            <div className="time-pill-wrapper">
              <span className="time-pill">
                {time}
              </span>
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="location-group">
          <div className="venue-detail-card location-card">
            <h3 className="card-heading">
              Location
            </h3>
            <div className="location-content">
              <MapPinIcon className="location-icon" />
              <div>
                <p className="location-venue">{venue}</p>
                <p className="location-campus">{campus}</p>
              </div>
            </div>
          </div>

          <div className="wayfinding-note-box">
            <p className="wayfinding-note-text">
              The meeting will be held at <strong>{locationText}</strong>.
              Wayfinding signs on campus will guide you from the main gates to
              the hall.
            </p>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="map-embed-container">
        <h2 className="map-heading">
          <MapPinIcon className="map-heading-icon" />
          Find {venue} on the map
        </h2>
        <div className="map-frame-wrapper">
          <iframe
            src={mapEmbedUrl}
            title={`Map of ${locationText}`}
            width="100%"
            height="420"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}

/* ---------- Schedule (coming soon) ---------- */
/* ---------- Schedule (timeline) ---------- */
function ScheduleSection() {
  const sessions = [
    { time: "09:00–09:40", title: "Registration" },
    { time: "09:40–11:00", title: "Keynote lecture" },
    { time: "11:00–11:30", title: "Tea/Coffee break" },
    { time: "11:30–13:00", title: "Getting to know each other" },
    {
      time: "14:00–16:00",
      title: "Women in IITs: Experiences, roles and reflections",
    },
    { time: "16:00–17:00", title: "Way forward" },
    { time: "17:00–19:00", title: "Networking over High-Tea" },
  ];

  return (
    <section className="schedule-section-container">
      <div className="schedule-header">
        <p className="schedule-tag">Schedule</p>
        <h3 className="schedule-title">Program — 15 November 2025</h3>
        <p className="schedule-subtitle">Seminar Hall, IIT Delhi</p>
      </div>

      <div className="venue-detail-card schedule-card">
        <h3 className="card-heading">Day Timeline</h3>

        <ol className="tl" aria-label="Event schedule timeline">
          {sessions.map((s, i) => (
            <li key={i} className="tl-item">
              <div className="tl-pin" aria-hidden="true">
                <span className="tl-pin-inner" />
              </div>

              <div className="tl-row">
                <span className="time-pill tl-time">{s.time}</span>
                <div className="tl-card">
                  <h4 className="tl-title">{s.title}</h4>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}



/* ---------- Tab Switcher ---------- */
function Tabs({ active, onChange }) {
  // NOTE: The original Tailwind had a color-[#7a5140] for idle. 
  // I've translated it to a hex value in the CSS and kept the hover:text-red-500 intent.
  const getTabClass = (tabName) => 
    `tab-button ${active === tabName ? 'tab-active' : 'tab-idle'}`;

  return (
    <div className="tabs-container-wrapper">
      <div className="tabs-container">
        <div className="tabs-content">
          <button
            className={getTabClass("venue")}
            onClick={() => onChange("venue")}
            aria-pressed={active === "venue"}
          >
            Venue
          </button>
          <button
            className={getTabClass("schedule")}
            onClick={() => onChange("schedule")}
            aria-pressed={active === "schedule"}
          >
            Schedule
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------- Meet Page ---------- */
export default function Meet({ PNG }) {
  const [tab, setTab] = useState("venue");

  return (
    <main className="meet-page-main">
      {/* Background gradient + image */}
      {/* <div className="background-layers">
        <div className="background-gradient" />
        <div
          className="background-image"
          style={{ backgroundImage: `url(${PNG.bg})` }}
        />
      </div> */}

      {/* Tabs */}
      <Tabs active={tab} onChange={setTab} />

      {/* Panels */}
      {tab === "venue" ? (
        <VenueSection />
      ) : (
        <ScheduleSection />
      )}
    </main>
  );
}